/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import FullPageLayout from "../../../../../templates/FullPageLayout";
import Header from "./Components/Header";
import { NeedHelp } from "../../../../../atoms/CustomIcons";
import { Button, Card, Col, Dropdown, Image, Row } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { useAppDispatch, useAppSelector } from "../../../../../config/hooks";
import { PopUp } from "../../../../../atoms/PopUp";
import CatalogueModal from "./Components/CatalogueModal";
import { AxiosError, AxiosResponse } from "axios";
import { ErrorMessage } from "../../../../../atoms/Toasts/ErrorMessage";
import { SuccessMessage } from "../../../../../atoms/Toasts/SuccessMessage";
import ChooseServiceLine from "./Components/ChooseServiceLine";
import { useNavigate } from "react-router-dom";
import EstimateSidebar from "./Components/Sidebar";
import { calculateServiceIntervals } from "./Components/Utils";
import EstimateDropDown from "./Components/Dropdown";
import EstimateServices from "./Components/EstimateServices";
import EmptyCard from "../../../../../atoms/EmptyCard";
import {
  ServiceLineType,
  SubmitEstimateType,
  SubmitServiceLinesType,
  SubServiceType,
} from "../../../../PotentialDeals/ducks/types";
import {
  getCurrentProposalById,
  getCurrentProposalDetailById,
  getPotentialDealDetails,
  getProposalById,
  getProposalDetailById,
  getProposalFormData,
  removeCurrentProposalById,
  removeProposalById,
} from "../../../../PotentialDeals/ducks/actions";
import { saveProposal } from "../../../../PotentialDeals/ducks/services";
import { getContractById } from "../../../ducks/actions";

export default function ContractChangeOrder() {
  const [loading, setLoading] = useState(false);
  const [catalogueModalVisible, setCatalogueModalVisible] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const locationUrl = window.location.pathname;
  const pathSegments = locationUrl.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const estimateId = pathSegments[pathSegments.length - 2];
  const proposalId = pathSegments[pathSegments.length - 3];
  const contractId = pathSegments[pathSegments.length - 4];
  const changeOrderId = pathSegments[pathSegments.length - 5];
  const currentAcceptedProposalId = pathSegments[pathSegments.length - 6];
  // const [activeId, setActiveId] = useState<null | string>(null);
  const [activeServiceLineId, setActiveServiceLineId] = useState<null | string>(
    null
  );
  const [activeRecord, setActiveRecord] = useState<SubServiceType | null>(null);
  const [activeType, setActiveType] = useState<null | string>(null);
  const [activeServiceId, setActiveServiceId] = useState<null | string>(null);
  // console.log("pathSegments--", activeRecord, activeType, activeServiceLineId);
  const [combineDropDown, setCombineDropDown] = useState<any[]>([]);
  const [estimateChanges, setEstimateChanges] = useState<any[]>([]);
  const [addedNewServices, setAddedNewServices] = useState<any[]>([]);
  const [textAreaContent, setTextAreaContent] = useState("");
  const proposalDetailData = useAppSelector(
    (state) => state?.potentialDeal?.proposalDetailData
  );
  const estimateFormData = useAppSelector(
    (state) => state?.potentialDeal?.estimateFormData
  );

  const proposalData = useAppSelector(
    (state) => state?.potentialDeal?.proposalData
  );
  const currentProposalData = useAppSelector(
    (state) => state?.potentialDeal?.currentProposalData
  );

  const contractDetailData = useAppSelector(
    (state) => state?.contract?.contractDetailData
  );

  const items = [
    {
      key: "1",
      disabled: true,
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/estimate/sorting.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
          disabled={true}
        >
          Sort services
        </Button>
      ),
    },
    {
      key: "2",
      disabled: true,
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/estimate/refresh.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
          disabled={true}
        >
          Sync material costs with inventory
        </Button>
      ),
    },
    {
      key: "3",
      disabled: true,
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/estimate/reset.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
          disabled={true}
        >
          Reset all numbers to default
        </Button>
      ),
    },
  ];

  useEffect(() => {
    if (companyId) {
      dispatch(getProposalFormData(companyId));
    }
  }, [dispatch, companyId]);

  useEffect(() => {
    setEstimateChanges([]);
    dispatch(removeCurrentProposalById(true));
    dispatch(removeProposalById(true));
  }, [dispatch]);

  useEffect(() => {
    if (contractId) {
      dispatch(getContractById(contractId));
    }
  }, [dispatch, contractId]);

  const cataloguePopUp = {
    visibility: catalogueModalVisible,
    class: "upload_photo_modal select_service_popup",
    content: <CatalogueModal onClose={() => setCatalogueModalVisible(false)} />,
    width: 1552,
    onCancel: () => setCatalogueModalVisible(false),
  };

  const [selectedServiceIds, setSelectedServiceIds] = useState<string[]>([]);
  const [groupedData, setGroupedData] = useState<any[]>([]);
  const [showServicePopUp, setShowServicePopUp] = useState<boolean>(false);
  const [serviceLineForLineItems, setServiceLineForLineItems] =
    useState<ServiceLineType | null>(null);
  const [serviceLineForMaterials, setServiceLineForMaterials] = useState<
    any | null
  >(null);

  const createPlaceholderLineItem = () => ({
    name: "",
    total_cost: 0,
    total_price: 0,
    gross_margin_perc: 0,
  });

  // function mergeDeepServiceLine(existing: any, incoming: any) {
  //   console.log("existing", existing, incoming);
  //   return {
  //     ...incoming,
  //     line_items: existing.line_items ?? incoming.line_items,
  //     service_groups: incoming.service_groups?.map((group: any) => {
  //       const existingGroup = existing.service_groups?.find(
  //         (g: any) => g.id === group.id
  //       );
  //       return {
  //         ...group,
  //         services: group.services?.map((srv: any) => {
  //           const existingSrv = existingGroup?.services?.find(
  //             (s: any) => s.entity_id === srv.entity_id
  //           );
  //           return {
  //             ...srv,
  //             ...existingSrv, // this keeps the previous changes like qty, cost, etc.
  //           };
  //         }),
  //       };
  //     }),
  //     services: incoming.services?.map((srv: any) => {
  //       const existingSrv = existing.services?.find(
  //         (s: any) => s.entity_id === srv.entity_id
  //       );
  //       return {
  //         ...srv,
  //         ...existingSrv,
  //       };
  //     }),
  //   };
  // }

  console.log("serviceLineForMaterials", serviceLineForMaterials);

  const handleAddServices = (
    newServicesArray: any[],
    newSubServicesArray: any[]
  ) => {
    setEstimateChanges((prevChanges: any) => {
      const changes = prevChanges ?? [];
      const updatedChanges = [...changes];

      newServicesArray.forEach((service) => {
        // Check if this service was removed earlier → remove the delete log instead of adding new
        const deleteIndex = updatedChanges.findIndex(
          (c: any) =>
            c.service_id === service?.id && c.change_field === "delete"
        );

        if (deleteIndex > -1) {
          updatedChanges.splice(deleteIndex, 1); // remove delete log
        } else {
          // Otherwise, add new "added_service" log
          updatedChanges.push({
            service_line_id: service.service_line_id,
            service_name: service?.name || "",
            service_id: service?.id || "",
            change_field: "added_service",
            type: "service",
            parent_service: service?.parent_id
              ? newSubServicesArray?.find((e) => e.id === service.parent_id)
                  ?.name
              : null,
            oldValue: null,
            newValue: null,
          });
        }
      });

      return updatedChanges;
    });
  };

  function mergeDeepServiceLine(existing: any, incoming: any) {
    const existingGroups = Array.isArray(existing.service_groups)
      ? existing.service_groups
      : [];
    const incomingGroups = Array.isArray(incoming.service_groups)
      ? incoming.service_groups
      : [];

    const existingServices = Array.isArray(existing.services)
      ? existing.services
      : [];
    const incomingServices = Array.isArray(incoming.services)
      ? incoming.services
      : [];

    const mergedServiceGroups = incomingGroups.map((group: any) => {
      const existingGroup = existingGroups.find((g: any) => g.id === group.id);
      return {
        ...group,
        services:
          group.services?.map((srv: any) => {
            const existingSrv = existingGroup?.services?.find(
              (s: any) => s.entity_id === srv.entity_id
            );
            return {
              ...srv,
              ...existingSrv,
            };
          }) ?? [],
      };
    });

    // Merge services
    const mergedServices = incomingServices.map((srv: any) => {
      const existingSrv = existingServices.find(
        (s: any) => s.entity_id === srv.entity_id
      );
      return {
        ...srv,
        ...existingSrv,
      };
    });

    return {
      ...incoming,
      line_items: existing.line_items ?? incoming.line_items,
      service_groups: mergedServiceGroups.length ? mergedServiceGroups : [],
      services: mergedServices.length ? mergedServices : [],
    };
  }

  const handleEstimateData = () => {
    const transformServiceArray = estimateFormData?.services?.filter(
      (service) => selectedServiceIds.includes(service.id)
    );

    // const transformMaterialArray = estimateFormData?.materials?.filter((mat) =>
    //   selectedServiceIds.includes(mat.id)
    // );

    const transformServiceLineArray = estimateFormData?.service_lines?.filter(
      (serviceLine) =>
        transformServiceArray?.some(
          (service) => service.service_line_id === serviceLine.id
        )
    );

    const transformServiceGroupArray = estimateFormData?.service_groups?.filter(
      (serviceGroup) =>
        transformServiceArray?.some(
          (service) => service.parent_id === serviceGroup.id
        )
    );

    const transformServiceDataArray = transformServiceArray?.filter(
      (service) => !service?.parent_id
    );

    // const transformMatServiceLineArray =
    //   estimateFormData?.service_lines?.filter((serviceLine) =>
    //     transformMaterialArray?.some(
    //       () => serviceLineForMaterials === serviceLine.id
    //     )
    //   );

    const newServicesArray = estimateFormData?.services?.filter((service) =>
      addedNewServices.includes(service.id)
    );
    const newSubServicesArray = estimateFormData?.service_groups?.filter(
      (serviceGroup) =>
        newServicesArray?.some(
          (service) => service.parent_id === serviceGroup.id
        )
    );

    console.log("newServicesArray", newSubServicesArray, newServicesArray);

    handleAddServices(newServicesArray ?? [], newSubServicesArray ?? []);
    setAddedNewServices([]);

    const newGroupedData: any = (transformServiceLineArray ?? []).map(
      (serviceLine, index) => {
        return {
          service_line_id: serviceLine.id,
          name: serviceLine.name,
          color: serviceLine.color,
          labor_rate: serviceLine?.labor_rate || 0,
          total_cost: 0,
          total_price: 0,
          gross_margin_perc: 0,
          index: index + 1,
          // materials:
          //   (transformMaterialArray ?? [])?.length > 0
          //     ? (transformMaterialArray ?? [])?.map((mat) => {
          //         return {
          //           entity_id: mat.id,
          //           name: mat.name,
          //           cost: mat.cost,
          //           qty: 0,
          //           total_cost: 0,
          //           total_price: 0,
          //           gross_margin_perc: 0,
          //           unit: mat?.unit?.singular_name || "",
          //         };
          //       })
          //     : undefined,
          service_groups:
            (transformServiceGroupArray ?? [])?.length > 0
              ? (transformServiceGroupArray ?? [])
                  .filter(
                    (serviceGroup) =>
                      serviceGroup.service_line_id === serviceLine.id
                  )
                  .map((serviceGroup, ind) => ({
                    id: serviceGroup.id,
                    name: serviceGroup.name,
                    complexity: 0,
                    hrs_per_visit: 0,
                    total_cost: 0,
                    total_price: 0,
                    gross_margin_perc: 0,
                    index: ind + 1,
                    image_url: serviceGroup?.image_url || "",
                    services:
                      (transformServiceArray ?? [])
                        .filter(
                          (service) =>
                            service.service_line_id === serviceLine.id
                        )
                        .filter(
                          (service) => service.parent_id === serviceGroup.id
                        )?.length > 0
                        ? (transformServiceArray ?? [])
                            .filter(
                              (service) =>
                                service.service_line_id === serviceLine.id
                            )
                            .filter(
                              (service) => service.parent_id === serviceGroup.id
                            )
                            .map((service, i) => ({
                              index: i + 1,
                              frequency: service?.frequency || "",
                              entity_id: service.id,
                              name: service.name,
                              qty: 0,
                              prod_rate: service?.production_rate || 0,
                              hrs_per_visit: 0,
                              labor_hrs: 0,
                              labor_price: 0,
                              total_labor_cost: 0,
                              total_labor_price: 0,
                              total_material_cost: 0,
                              total_material_price: 0,
                              total_cost: 0,
                              total_price: 0,
                              unit: service?.unit?.singular_name
                                ? service?.unit?.singular_name
                                : service?.takeoff?.unit?.singular_name || "",
                              labor_gross_margin_perc: 0,
                              material_gross_margin_perc: 0,
                              gross_margin_perc: 0,
                              image_url: service?.image_url || "",
                              no_of_materials:
                                service?.serviceMaterials?.length || 0,
                              who_performs: service?.service_provision_type,
                              visit:
                                service?.frequency === "one_time"
                                  ? 1
                                  : contractDetailData?.data?.start_date &&
                                    contractDetailData?.data?.end_date &&
                                    service?.frequency &&
                                    Math.round(
                                      calculateServiceIntervals(
                                        contractDetailData?.data?.start_date,
                                        contractDetailData?.data?.end_date,
                                        service?.frequency
                                      )
                                    ),
                              material: (service?.serviceMaterials || []).map(
                                (material, matInd) => ({
                                  index: matInd + 1,
                                  entity_id: material.material_id,
                                  name: material.material?.name,
                                  use_rate: material?.use_rate || 0,
                                  total_need: 0,
                                  unit_cost: material?.material?.cost ?? 0,
                                  unit_price: 0,
                                  total_cost: 0,
                                  total_price: 0,
                                  gross_margin_perc: 0,
                                  unit_order: material?.unit_order,
                                  unit: service?.unit?.singular_name
                                    ? service?.unit?.singular_name || ""
                                    : service?.takeoff?.unit?.singular_name ||
                                      "",
                                })
                              ),
                            }))
                        : undefined,
                  }))
              : undefined,
          services:
            (transformServiceDataArray ?? []).filter(
              (service) => service.service_line_id === serviceLine.id
            )?.length > 0
              ? (transformServiceDataArray ?? [])
                  .filter(
                    (service) => service.service_line_id === serviceLine.id
                  )
                  .map((service, i) => ({
                    index: i + 1,
                    frequency: service?.frequency || "",
                    entity_id: service.id,
                    name: service.name,
                    qty: 0,
                    prod_rate: service?.production_rate ?? 0,
                    hrs_per_visit: 0,
                    labor_hrs: 0,
                    labor_price: 0,
                    total_labor_cost: 0,
                    total_labor_price: 0,
                    total_material_cost: 0,
                    total_material_price: 0,
                    total_cost: 0,
                    total_price: 0,
                    labor_gross_margin_perc: 0,
                    unit: service?.unit?.singular_name
                      ? service?.unit?.singular_name
                      : service?.takeoff?.unit?.singular_name || "",
                    material_gross_margin_perc: 0,
                    gross_margin_perc: 0,
                    image_url: service?.image_url || "",
                    no_of_materials: service?.serviceMaterials?.length || 0,
                    who_performs: service?.service_provision_type,
                    visit:
                      service?.frequency === "one_time"
                        ? 1
                        : contractDetailData?.data?.start_date &&
                          contractDetailData?.data?.end_date &&
                          service?.frequency &&
                          Math.round(
                            calculateServiceIntervals(
                              contractDetailData?.data?.start_date,
                              contractDetailData?.data?.end_date,
                              service?.frequency
                            )
                          ),
                    material: (service?.serviceMaterials || []).map(
                      (material, matInd) => ({
                        index: matInd + 1,
                        entity_id: material.material_id,
                        name: material.material?.name,
                        use_rate: material?.use_rate || 0,
                        total_need: 0,
                        unit_cost: material?.material?.cost ?? 0,
                        unit_price: 0,
                        total_cost: 0,
                        total_price: 0,
                        gross_margin_perc: 0,
                        unit_order: material?.unit_order,
                        unit: service?.unit?.singular_name
                          ? service?.unit?.singular_name || ""
                          : service?.takeoff?.unit?.singular_name || "",
                      })
                    ),
                  }))
              : undefined,
        };
      }
    );

    // console.log("newGroupedData", newGroupedData);

    const mergedGroupedData: any[] = [];
    newGroupedData.forEach((newItem: any) => {
      const existingItem = groupedData.find(
        (g) => g.service_line_id === newItem.service_line_id
      );

      // console.log("existingItem", existingItem, newItem);

      if (existingItem) {
        mergedGroupedData.push(mergeDeepServiceLine(existingItem, newItem));
      } else {
        mergedGroupedData.push(newItem);
      }
    });

    // console.log("mergedGroupedData", mergedGroupedData);

    let finalGroupedData = [...mergedGroupedData]; // Create a new array reference

    if (serviceLineForLineItems) {
      const existingServiceLineIndex = finalGroupedData.findIndex(
        (item) => item.service_line_id === serviceLineForLineItems.id
      );

      if (existingServiceLineIndex !== -1) {
        // Case 1: Matching Service Line found - Add LineItem to its existing line_items array
        finalGroupedData = finalGroupedData.map((item, idx) => {
          if (idx === existingServiceLineIndex) {
            return {
              ...item,
              line_items: [
                // ...(item?.line_items || undefined), // Append to existing line items
                createPlaceholderLineItem(),
              ],
            };
          }
          return item;
        });
      } else {
        // Case 2: No matching Service Line found in the *merged* data.
        // This implies serviceLineForLineItems is completely new or wasn't part of estimateFormData's selection.
        const newServiceLineEntry: SubmitServiceLinesType = {
          service_line_id: serviceLineForLineItems.id,
          name: serviceLineForLineItems.name,
          color: serviceLineForLineItems.color,
          labor_rate: 0,
          total_cost: 0,
          total_price: 0,
          gross_margin_perc: 0,
          index:
            (finalGroupedData.length > 0
              ? Math.max(...finalGroupedData.map((d) => d.index))
              : 0) + 1, // Assign a unique index
          line_items: createPlaceholderLineItem()
            ? [createPlaceholderLineItem()]
            : undefined,
          service_groups: [],
          services: [],
        };
        finalGroupedData.push(newServiceLineEntry);
      }
    }
    setGroupedData(finalGroupedData);
    setServiceLineForLineItems(null); // Reset after processing
  };

  console.log("groupedData--", groupedData);

  // const sentProposalDocFunc = (id: string) => {
  //   setLoading(true);
  //   const payload = {
  //     proposal_id: id ?? "",
  //     companyId: companyId,
  //   };
  //   sentProposalDoc(payload)
  //     .then(() => {
  //       setLoading(false);
  //       navigate(`/editor/${id}/${estimateId}/${companyId}`);
  //     })
  //     .catch((e: unknown) => {
  //       if (e instanceof AxiosError) {
  //         setLoading(false);
  //         ErrorMessage(
  //           e?.response?.data?.error?.message ?? "Something went wrong"
  //         );
  //       } else {
  //         setLoading(false);
  //         ErrorMessage("Something went wrong");
  //       }
  //     });
  // };

  console.log(
    "pathSegments.includes('change-order')======",
    pathSegments.includes("change-order")
  );

  const handleSubmitEstimate = () => {
    setLoading(true);

    let calculatedTotalAmount = 0;
    let calculatedTotalCost = 0;
    // let totalServiceLineCost = 0;
    // let totalServiceLinePrice = 0;
    // let totalSubServiceCost = 0;
    // let totalSubServicePrice = 0;
    let hrsPerVisit = 0;

    groupedData?.forEach((groupData: any) => {
      // calculatedTotalAmount += groupData.total_price || 0;
      // calculatedTotalCost += groupData.total_cost || 0;
      // gmTotalMargin += groupData.gross_margin_perc * groupData.total_price || 0;

      (groupData?.service_groups ?? []).forEach((serviceGroup: any) => {
        serviceGroup?.services?.forEach((service: any) => {
          calculatedTotalAmount += service?.total_price || 0;
          calculatedTotalCost += service?.total_cost || 0;
          // totalServiceLineCost += service?.total_cost || 0;
          // totalServiceLinePrice += service?.total_price || 0;
          // totalSubServiceCost += service?.total_cost || 0;
          // totalSubServicePrice += service?.total_price || 0;
          // console.log(
          //   "service?.total_cost totalSubServiceCost",
          //   totalSubServiceCost
          // );
        });
      });

      // Calculate total cost from top-level services
      (groupData?.services ?? []).forEach((service: any) => {
        // totalServiceLineCost += service?.total_cost || 0;
        // totalServiceLinePrice += service?.total_price || 0;
        calculatedTotalAmount += service?.total_price || 0;
        calculatedTotalCost += service?.total_cost || 0;
      });

      (groupData?.line_items ?? []).forEach((items: any) => {
        calculatedTotalCost += items?.total_cost || 0;
        calculatedTotalAmount += items?.total_price || 0;
      });
    });

    let grossMargin = 0;
    if (calculatedTotalAmount && calculatedTotalCost) {
      grossMargin = parseFloat(
        Number(
          ((calculatedTotalAmount - calculatedTotalCost) /
            calculatedTotalAmount) *
            100
        ).toFixed(1)
      );
    }
    // console.log("totalSubServiceCost", totalSubServiceCost);

    const SALES_TAX_PERCENTAGE = 8.5;
    const salesTaxTotalAmount =
      calculatedTotalAmount * (SALES_TAX_PERCENTAGE / 100);

    const totalAmountIncludingTax = calculatedTotalAmount + salesTaxTotalAmount;

    let deltaAmount = 0;
    if (
      currentProposalData?.data?.total_price &&
      currentProposalData?.data?.total_price > calculatedTotalAmount
    ) {
      deltaAmount =
        currentProposalData?.data?.total_price - calculatedTotalAmount;
    } else if (
      currentProposalData?.data?.total_price &&
      currentProposalData?.data?.total_price < calculatedTotalAmount
    ) {
      deltaAmount =
        calculatedTotalAmount - currentProposalData?.data?.total_price;
    }

    let changeType = "";

    if (pathSegments.includes("change-order")) {
      changeType = "change_order";
    } else {
      changeType = "upsell";
    }

    if (
      currentProposalData?.data?.total_price &&
      currentProposalData?.data?.total_price > calculatedTotalAmount &&
      changeType === "upsell"
    ) {
      // If the current proposal price is greater than the calculated amount and we were about to treat this as an upsell,
      // prompt the user to confirm converting it to a change order.
      import("antd").then(({ Modal }) => {
        Modal.confirm({
          title: "Convert to change order?",
          content:
            "The current proposal total is greater than the calculated total. This should be saved as a change order, not an upsell. Do you want to convert to a change order and continue?",
          okText: "Convert to change order",
          cancelText: "Cancel",
          onOk() {
            // mark as change order and submit immediately
            changeType = "change_order";

            const payload: SubmitEstimateType = {
              // delta: deltaAmount,
              deal_id: estimateId,
              company_id: companyId,
              // is_change_order: true,
              // contract_id: contractId,
              proposal_id: pathSegments.length === 7 ? proposalId : undefined,
              // change_order_id: pathSegments.length === 7 ? changeOrderId : undefined,
              gross_margin_perc: grossMargin || 0,
              total_amount: totalAmountIncludingTax || 0,
              labor_amount: 0,
              material_amount: 0,
              subcontractor_amount: 0,
              other_amount: 0,
              summary: textAreaContent ?? "",
              total_cost: calculatedTotalCost,
              sales_tax_perc: 0,
              total_price: calculatedTotalAmount || 0,
              sales_tax_total_amount: salesTaxTotalAmount,

              change_order_data: {
                delta: deltaAmount,
                change_order_id:
                  pathSegments.length === 7 ? changeOrderId : undefined,
                contract_id: contractId,
                resulted_amount: calculatedTotalAmount,
                resulted_gross_margin: grossMargin,
                change_details: estimateChanges ?? [],
                type: "change_order",
              },
              services_lines: groupedData?.map((groupData: any) => {
                const laborPrice =
                  (groupData?.labor_rate * 100) /
                  (100 - groupData?.gross_margin_perc || 0);

                return {
                  ...groupData,
                  // total_price: calculatedTotalAmount || 0,
                  // total_cost: calculatedTotalCost || 0,

                  service_groups: groupData?.service_groups?.map(
                    (serviceGroup: any) => {
                      const visits = serviceGroup?.services?.map(
                        (item: { visit: string }) => item.visit
                      );

                      let groupLabourHrs = 0;
                      let singleLabourHrs = 0;
                      let groupLaborCost = 0;
                      let groupLaborPrice = 0;
                      serviceGroup?.services?.forEach((service: any) => {
                        const HourPerVisit =
                          service?.qty / service?.prod_rate || 0;
                        if (service?.frequency === "one_time") {
                          groupLabourHrs += HourPerVisit ?? 0;
                          singleLabourHrs = HourPerVisit ?? 0;
                        } else {
                          groupLabourHrs += HourPerVisit * service?.visit || 0;
                          singleLabourHrs = HourPerVisit * service?.visit || 0;
                        }

                        groupLaborCost +=
                          singleLabourHrs * groupData?.labor_rate;
                        groupLaborPrice += singleLabourHrs * laborPrice || 0;
                      });

                      return {
                        ...serviceGroup,
                        visit: visits ? Math.max(...visits) : 1,
                        labor_hrs: groupLabourHrs,
                        total_labor_cost: groupLaborCost,
                        total_labor_price: groupLaborPrice,
                        services: serviceGroup?.services?.map(
                          (service: any) => {
                            const HourPerVisit =
                              service?.qty / service?.prod_rate || 0;
                            let laborHours = 0;
                            if (service?.frequency === "one_time") {
                              laborHours = HourPerVisit ?? 0;
                            } else {
                              laborHours = HourPerVisit * service?.visit || 0;
                            }

                            hrsPerVisit += laborHours / service?.visit || 0;
                            let totalMaterialCost = 0;
                            let totalMaterialPrice = 0;
                            service.material.forEach((mat: any) => {
                              if (mat?.unit_cost && mat?.use_rate) {
                                const unitPrice =
                                  (mat?.unit_cost * 100) /
                                  (100 - groupData?.gross_margin_perc);
                                const singleTotalNeed =
                                  service?.qty / mat.use_rate || 0;
                                totalMaterialCost +=
                                  singleTotalNeed * mat?.unit_cost || 0;
                                totalMaterialPrice +=
                                  singleTotalNeed * unitPrice || 0;
                              }
                            });
                            return {
                              ...service,
                              hrs_per_visit: hrsPerVisit || 0,
                              labor_hrs: laborHours,
                              labor_price: laborPrice,
                              total_labor_cost:
                                laborHours * groupData?.labor_rate,
                              total_labor_price: laborHours * laborPrice,
                              total_material_cost: totalMaterialCost,
                              total_material_price: totalMaterialPrice,
                              labor_gross_margin_perc:
                                groupData?.gross_margin_perc || 0,
                              material_gross_margin_perc:
                                groupData?.gross_margin_perc || 0,
                            };
                          }
                        ),
                      };
                    }
                  ),
                  services: groupData?.services?.map((service: any) => {
                    const HourPerVisit = service?.qty / service?.prod_rate || 0;
                    let laborHours = 0;
                    if (service?.frequency === "one_time") {
                      laborHours = HourPerVisit ?? 0;
                    } else {
                      laborHours = HourPerVisit * service?.visit || 0;
                    }

                    hrsPerVisit += laborHours / service?.visit || 0;
                    let totalMaterialCost = 0;
                    let totalMaterialPrice = 0;
                    service.material.forEach((mat: any) => {
                      if (mat?.unit_cost && mat?.use_rate) {
                        const unitPrice =
                          (mat?.unit_cost * 100) /
                          (100 - groupData?.gross_margin_perc);
                        const singleTotalNeed =
                          service?.qty / mat.use_rate || 0;
                        totalMaterialCost +=
                          singleTotalNeed * mat?.unit_cost || 0;
                        totalMaterialPrice += singleTotalNeed * unitPrice || 0;
                      }
                    });
                    return {
                      ...service,
                      hrs_per_visit: hrsPerVisit || 0,
                      labor_hrs: laborHours,
                      labor_price: laborPrice,
                      total_labor_cost: laborHours * groupData?.labor_rate,
                      total_labor_price: laborHours * laborPrice,
                      total_material_cost: totalMaterialCost,
                      total_material_price: totalMaterialPrice,
                      labor_gross_margin_perc:
                        groupData?.gross_margin_perc || 0,
                      material_gross_margin_perc:
                        groupData?.gross_margin_perc || 0,
                    };
                  }),
                };
              }) as SubmitServiceLinesType[],
            };

            saveProposal(payload)
              .then(() => {
                setLoading(false);
                SuccessMessage(
                  `Change order ${
                    pathSegments.length === 5 ? "updated" : "created"
                  }`
                );
                navigate(`/contracts/profile/${contractId}/${companyId}`);
              })
              .catch((e: unknown) => {
                if (e instanceof AxiosError) {
                  setLoading(false);
                  ErrorMessage(
                    e?.response?.data?.error?.message ?? "Something went wrong"
                  );
                } else {
                  setLoading(false);
                  ErrorMessage("Something went wrong");
                }
              });
          },

          onCancel() {
            setLoading(false);
          },
        });
      });
      return;
    }

    const payload: SubmitEstimateType = {
      // delta: deltaAmount,
      deal_id: estimateId,
      company_id: companyId,
      // is_change_order: true,
      // contract_id: contractId,
      proposal_id: pathSegments.length === 7 ? proposalId : undefined,
      // change_order_id: pathSegments.length === 7 ? changeOrderId : undefined,
      gross_margin_perc: grossMargin || 0,
      total_amount: totalAmountIncludingTax || 0,
      labor_amount: 0,
      material_amount: 0,
      subcontractor_amount: 0,
      other_amount: 0,
      summary: textAreaContent ?? "",
      total_cost: calculatedTotalCost,
      sales_tax_perc: 0,
      total_price: calculatedTotalAmount || 0,
      sales_tax_total_amount: salesTaxTotalAmount,

      change_order_data: {
        delta: deltaAmount,
        change_order_id: pathSegments.length === 7 ? changeOrderId : undefined,
        contract_id: contractId,
        resulted_amount: calculatedTotalAmount,
        resulted_gross_margin: grossMargin,
        change_details: estimateChanges ?? [],
        type: changeType,
      },
      services_lines: groupedData?.map((groupData: any) => {
        const laborPrice =
          (groupData?.labor_rate * 100) /
          (100 - groupData?.gross_margin_perc || 0);

        return {
          ...groupData,
          // total_price: calculatedTotalAmount || 0,
          // total_cost: calculatedTotalCost || 0,

          service_groups: groupData?.service_groups?.map(
            (serviceGroup: any) => {
              const visits = serviceGroup?.services?.map(
                (item: { visit: string }) => item.visit
              );

              let groupLabourHrs = 0;
              let singleLabourHrs = 0;
              let groupLaborCost = 0;
              let groupLaborPrice = 0;
              serviceGroup?.services?.forEach((service: any) => {
                const HourPerVisit = service?.qty / service?.prod_rate || 0;
                if (service?.frequency === "one_time") {
                  groupLabourHrs += HourPerVisit ?? 0;
                  singleLabourHrs = HourPerVisit ?? 0;
                } else {
                  groupLabourHrs += HourPerVisit * service?.visit || 0;
                  singleLabourHrs = HourPerVisit * service?.visit || 0;
                }

                groupLaborCost += singleLabourHrs * groupData?.labor_rate;
                groupLaborPrice += singleLabourHrs * laborPrice || 0;
              });

              return {
                ...serviceGroup,
                visit: visits ? Math.max(...visits) : 1,
                labor_hrs: groupLabourHrs,
                total_labor_cost: groupLaborCost,
                total_labor_price: groupLaborPrice,
                services: serviceGroup?.services?.map((service: any) => {
                  const HourPerVisit = service?.qty / service?.prod_rate || 0;
                  let laborHours = 0;
                  if (service?.frequency === "one_time") {
                    laborHours = HourPerVisit ?? 0;
                  } else {
                    laborHours = HourPerVisit * service?.visit || 0;
                  }

                  hrsPerVisit += laborHours / service?.visit || 0;
                  let totalMaterialCost = 0;
                  let totalMaterialPrice = 0;
                  service.material.forEach((mat: any) => {
                    if (mat?.unit_cost && mat?.use_rate) {
                      const unitPrice =
                        (mat?.unit_cost * 100) /
                        (100 - groupData?.gross_margin_perc);
                      const singleTotalNeed = service?.qty / mat.use_rate || 0;
                      totalMaterialCost +=
                        singleTotalNeed * mat?.unit_cost || 0;
                      totalMaterialPrice += singleTotalNeed * unitPrice || 0;
                    }
                  });
                  // console.log("laborHours", laborHours);
                  return {
                    ...service,
                    hrs_per_visit: hrsPerVisit || 0,
                    labor_hrs: laborHours,
                    labor_price: laborPrice,
                    total_labor_cost: laborHours * groupData?.labor_rate,
                    total_labor_price: laborHours * laborPrice,
                    total_material_cost: totalMaterialCost,
                    total_material_price: totalMaterialPrice,
                    labor_gross_margin_perc: groupData?.gross_margin_perc || 0,
                    material_gross_margin_perc:
                      groupData?.gross_margin_perc || 0,
                  };
                }),
              };
            }
          ),
          services: groupData?.services?.map((service: any) => {
            const HourPerVisit = service?.qty / service?.prod_rate || 0;
            let laborHours = 0;
            if (service?.frequency === "one_time") {
              laborHours = HourPerVisit ?? 0;
            } else {
              laborHours = HourPerVisit * service?.visit || 0;
            }

            hrsPerVisit += laborHours / service?.visit || 0;
            let totalMaterialCost = 0;
            let totalMaterialPrice = 0;
            service.material.forEach((mat: any) => {
              if (mat?.unit_cost && mat?.use_rate) {
                const unitPrice =
                  (mat?.unit_cost * 100) / (100 - groupData?.gross_margin_perc);
                const singleTotalNeed = service?.qty / mat.use_rate || 0;
                totalMaterialCost += singleTotalNeed * mat?.unit_cost || 0;
                totalMaterialPrice += singleTotalNeed * unitPrice || 0;
              }
            });
            // console.log("laborHours", laborHours);
            return {
              ...service,
              hrs_per_visit: hrsPerVisit || 0,
              labor_hrs: laborHours,
              labor_price: laborPrice,
              total_labor_cost: laborHours * groupData?.labor_rate,
              total_labor_price: laborHours * laborPrice,
              total_material_cost: totalMaterialCost,
              total_material_price: totalMaterialPrice,
              labor_gross_margin_perc: groupData?.gross_margin_perc || 0,
              material_gross_margin_perc: groupData?.gross_margin_perc || 0,
            };
          }),
        };
      }) as SubmitServiceLinesType[],
    };

    saveProposal(payload)
      .then(() => {
        setLoading(false);
        SuccessMessage(
          `Change order ${pathSegments.length === 5 ? "updated" : "created"}`
        );
        navigate(`/contracts/profile/${contractId}/${companyId}`);
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };
  const handleSubmitProposalDoc = () => {
    setLoading(true);

    let calculatedTotalAmount = 0;
    let calculatedTotalCost = 0;
    // let totalServiceLineCost = 0;
    // let totalServiceLinePrice = 0;
    let totalSubServiceCost = 0;
    let totalSubServicePrice = 0;
    let hrsPerVisit = 0;

    groupedData?.forEach((groupData: any) => {
      // calculatedTotalAmount += groupData.total_price || 0;
      // calculatedTotalCost += groupData.total_cost || 0;
      // gmTotalMargin += groupData.gross_margin_perc * groupData.total_price || 0;

      (groupData?.service_groups ?? []).forEach((serviceGroup: any) => {
        serviceGroup?.services?.forEach((service: any) => {
          calculatedTotalAmount += service?.total_price || 0;
          calculatedTotalCost += service?.total_cost || 0;
          // totalServiceLineCost += service?.total_cost || 0;
          // totalServiceLinePrice += service?.total_price || 0;
          totalSubServiceCost += service?.total_cost || 0;
          totalSubServicePrice += service?.total_price || 0;
          // console.log(
          //   "service?.total_cost totalSubServiceCost",
          //   totalSubServiceCost
          // );
        });
      });

      // Calculate total cost from top-level services
      (groupData?.services ?? []).forEach((service: any) => {
        // totalServiceLineCost += service?.total_cost || 0;
        // totalServiceLinePrice += service?.total_price || 0;
        calculatedTotalAmount += service?.total_price || 0;
        calculatedTotalCost += service?.total_cost || 0;
      });
    });

    let grossMargin = 0;
    if (calculatedTotalAmount && calculatedTotalCost) {
      grossMargin = parseFloat(
        Number(
          ((calculatedTotalAmount - calculatedTotalCost) /
            calculatedTotalAmount) *
            100
        ).toFixed(1)
      );
    }
    // console.log("totalSubServiceCost", totalSubServiceCost);

    const SALES_TAX_PERCENTAGE = 8.5;
    const salesTaxTotalAmount =
      calculatedTotalAmount * (SALES_TAX_PERCENTAGE / 100);

    const totalAmountIncludingTax = calculatedTotalAmount + salesTaxTotalAmount;

    // const payload: SubmitEstimateType = {
    //   deal_id: estimateId,
    //   company_id: companyId,
    //   proposal_id: pathSegments.length === 5 ? proposalId : undefined,
    //   gross_margin_perc: grossMargin || 0,
    //   total_amount: totalAmountIncludingTax || 0,
    //   total_price: calculatedTotalAmount || 0,
    //   labor_amount: 0,
    //   material_amount: 0,
    //   subcontractor_amount: 0,
    //   other_amount: 0,
    //   summary: textAreaContent ?? "",
    //   total_cost: calculatedTotalCost,
    //   sales_tax_perc: 0,
    //   sales_tax_total_amount: salesTaxTotalAmount,
    //   services_lines: groupedData?.map((groupData: any) => {
    //     return {
    //       ...groupData,
    //       total_price: calculatedTotalAmount || 0,
    //       total_cost: calculatedTotalCost || 0,

    //       service_groups: groupData?.service_groups?.map(
    //         (serviceGroup: any) => {
    //           return {
    //             ...serviceGroup,
    //             total_cost: totalSubServiceCost || 0,
    //             total_price: totalSubServicePrice || 0,
    //             services: serviceGroup?.services?.map((service: any) => {
    //               const HourPerVisit = service?.qty / service?.prod_rate || 0;
    //               const laborHours = HourPerVisit * service?.visit || 0;
    //               hrsPerVisit += laborHours / service?.visit || 0;
    //               return {
    //                 ...service,
    //                 hrs_per_visit: hrsPerVisit || 0,
    //               };
    //             }),
    //           };
    //         }
    //       ),
    //     };
    //   }) as SubmitServiceLinesType[],
    // };

    let deltaAmount = 0;
    if (
      currentProposalData?.data?.total_price &&
      currentProposalData?.data?.total_price > calculatedTotalAmount
    ) {
      deltaAmount =
        currentProposalData?.data?.total_price - calculatedTotalAmount;
    } else if (
      currentProposalData?.data?.total_price &&
      currentProposalData?.data?.total_price < calculatedTotalAmount
    ) {
      deltaAmount =
        calculatedTotalAmount - currentProposalData?.data?.total_price;
    }

    const payload: SubmitEstimateType = {
      // delta: deltaAmount,
      deal_id: estimateId,
      company_id: companyId,
      // is_change_order: true,
      // contract_id: contractId,
      proposal_id: pathSegments.length === 7 ? proposalId : undefined,
      // change_order_id: pathSegments.length === 7 ? changeOrderId : undefined,
      gross_margin_perc: grossMargin || 0,
      total_amount: totalAmountIncludingTax || 0,
      labor_amount: 0,
      material_amount: 0,
      subcontractor_amount: 0,
      other_amount: 0,
      summary: textAreaContent ?? "",
      total_cost: calculatedTotalCost,
      sales_tax_perc: 0,
      total_price: calculatedTotalAmount || 0,
      sales_tax_total_amount: salesTaxTotalAmount,
      change_order_data: {
        delta: deltaAmount,
        change_order_id: pathSegments.length === 7 ? changeOrderId : undefined,
        contract_id: contractId,
        resulted_amount: calculatedTotalAmount,
        resulted_gross_margin: grossMargin,
        change_details: estimateChanges ?? [],
        type:
          currentProposalData?.data?.total_price &&
          currentProposalData?.data?.total_price > calculatedTotalAmount
            ? "change_order"
            : "upsell",
      },
      services_lines: groupedData?.map((groupData: any) => {
        const laborPrice =
          (groupData?.labor_rate * 100) /
          (100 - groupData?.gross_margin_perc || 0);

        return {
          ...groupData,
          total_price: calculatedTotalAmount || 0,
          total_cost: calculatedTotalCost || 0,

          service_groups: groupData?.service_groups?.map(
            (serviceGroup: any) => {
              const visits = serviceGroup?.services?.map(
                (item: { visit: string }) => item.visit
              );

              let groupLabourHrs = 0;
              let singleLabourHrs = 0;
              let groupLaborCost = 0;
              let groupLaborPrice = 0;
              serviceGroup?.services?.forEach((service: any) => {
                const HourPerVisit = service?.qty / service?.prod_rate || 0;
                if (service?.frequency === "one_time") {
                  groupLabourHrs += HourPerVisit ?? 0;
                  singleLabourHrs = HourPerVisit ?? 0;
                } else {
                  groupLabourHrs += HourPerVisit * service?.visit || 0;
                  singleLabourHrs = HourPerVisit * service?.visit || 0;
                }

                groupLaborCost += singleLabourHrs * groupData?.labor_rate;
                groupLaborPrice += singleLabourHrs * laborPrice || 0;
              });

              return {
                ...serviceGroup,
                visit: visits ? Math.max(...visits) : 1,
                total_cost: totalSubServiceCost || 0,
                total_price: totalSubServicePrice || 0,
                labor_hrs: groupLabourHrs,
                total_labor_cost: groupLaborCost,
                total_labor_price: groupLaborPrice,
                services: serviceGroup?.services?.map((service: any) => {
                  const HourPerVisit = service?.qty / service?.prod_rate || 0;
                  let laborHours = 0;
                  if (service?.frequency === "one_time") {
                    laborHours = HourPerVisit ?? 0;
                  } else {
                    laborHours = HourPerVisit * service?.visit || 0;
                  }

                  hrsPerVisit += laborHours / service?.visit || 0;
                  let totalMaterialCost = 0;
                  let totalMaterialPrice = 0;
                  service.material.forEach((mat: any) => {
                    if (mat?.unit_cost && mat?.use_rate) {
                      const unitPrice =
                        (mat?.unit_cost * 100) /
                        (100 - groupData?.gross_margin_perc);
                      const singleTotalNeed = service?.qty / mat.use_rate || 0;
                      totalMaterialCost +=
                        singleTotalNeed * mat?.unit_cost || 0;
                      totalMaterialPrice += singleTotalNeed * unitPrice || 0;
                    }
                  });
                  // console.log("laborHours", laborHours);
                  return {
                    ...service,
                    hrs_per_visit: hrsPerVisit || 0,
                    labor_hrs: laborHours,
                    labor_price: laborPrice,
                    total_labor_cost: laborHours * groupData?.labor_rate,
                    total_labor_price: laborHours * laborPrice,
                    total_material_cost: totalMaterialCost,
                    total_material_price: totalMaterialPrice,
                    labor_gross_margin_perc: groupData?.gross_margin_perc || 0,
                    material_gross_margin_perc:
                      groupData?.gross_margin_perc || 0,
                  };
                }),
              };
            }
          ),
          services: groupData?.services?.map((service: any) => {
            const HourPerVisit = service?.qty / service?.prod_rate || 0;
            let laborHours = 0;
            if (service?.frequency === "one_time") {
              laborHours = HourPerVisit ?? 0;
            } else {
              laborHours = HourPerVisit * service?.visit || 0;
            }

            hrsPerVisit += laborHours / service?.visit || 0;
            let totalMaterialCost = 0;
            let totalMaterialPrice = 0;
            service.material.forEach((mat: any) => {
              if (mat?.unit_cost && mat?.use_rate) {
                const unitPrice =
                  (mat?.unit_cost * 100) / (100 - groupData?.gross_margin_perc);
                const singleTotalNeed = service?.qty / mat.use_rate || 0;
                totalMaterialCost += singleTotalNeed * mat?.unit_cost || 0;
                totalMaterialPrice += singleTotalNeed * unitPrice || 0;
              }
            });
            // console.log("laborHours", laborHours);
            return {
              ...service,
              hrs_per_visit: hrsPerVisit || 0,
              labor_hrs: laborHours,
              labor_price: laborPrice,
              total_labor_cost: laborHours * groupData?.labor_rate,
              total_labor_price: laborHours * laborPrice,
              total_material_cost: totalMaterialCost,
              total_material_price: totalMaterialPrice,
              labor_gross_margin_perc: groupData?.gross_margin_perc || 0,
              material_gross_margin_perc: groupData?.gross_margin_perc || 0,
            };
          }),
        };
      }) as SubmitServiceLinesType[],
    };

    saveProposal(payload)
      .then(async (res: AxiosResponse) => {
        if (res && res?.data?.id) {
          setLoading(false);
          navigate(
            `/document-editor/${res?.data?.id}/${estimateId}/${companyId}`
          );
          // sentProposalDocFunc(res?.data?.id);
        }
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const chooseServiceLinePopUp = {
    visibility: showServicePopUp,
    class: "upload_photo_modal",
    content: (
      <ChooseServiceLine
        title=""
        onClose={() => setShowServicePopUp(false)}
        heading="Choose service line"
        paragraph="There are no service lines in this estimate. Select one to add the service to."
        btnText="Add line item"
        modalData={estimateFormData?.service_lines}
        setServiceLineForLineItems={setServiceLineForLineItems}
        btnApi={() => {
          handleEstimateData();
          setShowServicePopUp(false);
        }}
        loading={loading}
      />
    ),
    width: 540,
    onCancel: () => setShowServicePopUp(false),
  };

  useEffect(() => {
    if (proposalId) {
      dispatch(getProposalById(proposalId));
      dispatch(getProposalDetailById(proposalId));
    }
  }, [proposalId, dispatch]);

  useEffect(() => {
    if (currentAcceptedProposalId) {
      dispatch(getCurrentProposalById(currentAcceptedProposalId));
      dispatch(getCurrentProposalDetailById(currentAcceptedProposalId));
    } else {
      dispatch(getCurrentProposalById(proposalId));
      dispatch(getCurrentProposalDetailById(proposalId));
    }
  }, [currentAcceptedProposalId, proposalId, dispatch]);

  useEffect(() => {
    if (estimateId && contractId) {
      dispatch(getPotentialDealDetails(estimateId, contractId));
    }
  }, [dispatch, estimateId, contractId]);

  useEffect(() => {
    if (proposalDetailData?.summary) {
      setTextAreaContent(proposalDetailData?.summary || "");
    }
  }, [proposalDetailData]);
  console.log("estimateChanges", estimateChanges);

  useEffect(() => {
    if (proposalData?.data?.change_details) {
      setEstimateChanges(proposalData?.data?.change_details || []);
    }
  }, [proposalData?.data]);
  return (
    <FullPageLayout loading={loading || proposalData?.loader}>
      <div className="estimateWrapper">
        <Header
          companyId={companyId}
          estimateId={contractId}
          btnText1="Need help?"
          btnIcon1={<NeedHelp />}
          btnText2="Proposal doc"
          setLoading={setLoading}
          dealsDetailData={contractDetailData?.data}
          proposalDetailData={proposalDetailData}
          addProposal={true}
          handleSubmitEstimate={handleSubmitEstimate}
          handleSubmitProposalDoc={handleSubmitProposalDoc}
          proposalId={proposalId}
          dealId={estimateId}
        />

        <Card className="estimateCard">
          <Row gutter={16} wrap={false}>
            <Col flex="auto">
              <Card className="estimateCardInner">
                <div className="estimateLeftHeader">
                  <EstimateDropDown
                    handleEstimateData={handleEstimateData}
                    estimateFormData={estimateFormData}
                    proposalData={proposalData}
                    setGroupedData={setGroupedData}
                    combineDropDown={combineDropDown}
                    setCombineDropDown={setCombineDropDown}
                    setSelectedServiceIds={setSelectedServiceIds}
                    selectedServiceIds={selectedServiceIds}
                    setServiceLineForMaterials={setServiceLineForMaterials}
                    loading={loading}
                    setEstimateChanges={setEstimateChanges}
                    setAddedNewServices={setAddedNewServices}
                  />

                  {/* <Button
                    onClick={() => setCatalogueModalVisible(true)}
                    className="ant-btn-primary"
                  >
                    Choose from catalogue
                  </Button> */}
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowServicePopUp(true);
                    }}
                    icon={
                      <Image
                        src="/images/estimate/addMore.svg"
                        preview={false}
                      />
                    }
                    style={{ width: "36px", height: "36px" }}
                  />
                  <Dropdown
                    menu={{
                      items,
                    }}
                    trigger={["click"]}
                    placement="bottomRight"
                    className="actionButton"
                  >
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      onKeyDown={(e) => e.stopPropagation()}
                      className="only_icon"
                      icon={<MoreOutlined />}
                      style={{ width: "36px", height: "36px" }}
                    />
                  </Dropdown>
                </div>

                {groupedData?.length > 0 ? (
                  <div className="estimateWrap">
                    {groupedData?.map((groupData: any, groupIndex: number) => {
                      return (
                        <EstimateServices
                          key={groupIndex}
                          setActiveRecord={setActiveRecord}
                          setActiveType={setActiveType}
                          groupData={groupData}
                          groupedData={groupedData}
                          groupIndex={groupIndex}
                          setGroupedData={setGroupedData}
                          companyId={companyId}
                          apiData={currentProposalData?.data}
                          setActiveServiceLineId={setActiveServiceLineId}
                          setActiveServiceId={setActiveServiceId}
                          selectedServiceIds={selectedServiceIds}
                          setSelectedServiceIds={setSelectedServiceIds}
                          setEstimateChanges={setEstimateChanges}
                        />
                      );
                    })}
                  </div>
                ) : (
                  <div className="empty_wrap estimateEmptyCard">
                    <EmptyCard
                      imageHeight={200}
                      title="No services selected yet"
                      description={
                        <>
                          You haven’t added any services yet. Search for a
                          service or
                          <br /> Choose from catalogue to find what you need.
                        </>
                      }
                      image="/images/empty-icons/no-archived.svg"
                    />
                  </div>
                )}
              </Card>
            </Col>
            <Col flex="328px">
              <EstimateSidebar
                setLoading={setLoading}
                setTextAreaContent={setTextAreaContent}
                textAreaContent={textAreaContent}
                activeRecord={activeRecord}
                groupedData={groupedData}
                newEstimate={true}
                activeServiceId={activeServiceId}
                estimateChanges={estimateChanges}
                apiData={currentProposalData?.data}
                singleGroupData={groupedData?.find(
                  (e) => e?.service_line_id === activeServiceLineId
                )}
                activeType={activeType}
                resetSidebar={() => {
                  setActiveRecord(null);
                  setActiveType(null);
                  setActiveServiceLineId(null);
                }}
              />
            </Col>
          </Row>
        </Card>
      </div>
      <PopUp {...cataloguePopUp} />
      <PopUp {...chooseServiceLinePopUp} />
    </FullPageLayout>
  );
}
